/**
 * @flow
 * @relayHash 834c5c58a87c49c543e75725a98a936a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CustomerList_customerEdges$ref = any;
export type CustomerSortField = "CREATED_AT" | "CUSTOMER_NUMBER" | "NAME" | "UPDATED_AT";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type CustomerSort = {|
  field: CustomerSortField,
  direction: SortDirection,
|};
export type CustomersQueryVariables = {|
  count: number,
  offset?: ?number,
  search?: ?string,
  sortBy?: ?CustomerSort,
  customerNumbers?: ?$ReadOnlyArray<string>,
  salesUserIds?: ?$ReadOnlyArray<string>,
|};
export type CustomersQueryResponse = {|
  +customers: {|
    +totalCount: number,
    +edges: ?$ReadOnlyArray<?{|
      +$fragmentRefs: CustomerList_customerEdges$ref
    |}>,
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
|};
export type CustomersQuery = {|
  variables: CustomersQueryVariables,
  response: CustomersQueryResponse,
|};
*/


/*
query CustomersQuery(
  $count: Int!
  $offset: Int
  $search: String
  $sortBy: CustomerSort
  $customerNumbers: [String!]
  $salesUserIds: [ID!]
) {
  customers(first: $count, offset: $offset, search: $search, sortBy: $sortBy, customerNumbers: $customerNumbers, salesUserIds: $salesUserIds) {
    totalCount
    edges {
      ...CustomerList_customerEdges
    }
  }
  viewer {
    id
    permissions
  }
}

fragment CustomerList_customerEdges on CustomerEdge {
  node {
    id
    customerNumber
    name
    openOrders
    salesUser {
      ...UserAvatar_user
      id
    }
    ...AddUpdateCustomerModal_customer
  }
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment AddUpdateCustomerModal_customer on Customer {
  id
  name
  primaryContactName
  secondaryContactName
  addresses {
    id
    label
    addressLine1
    addressLine2
    addressLine3
    addressCity
    addressState
    addressZip
    addressCountry
    isDefault
  }
  billingAddressLine1
  billingAddressLine2
  billingAddressLine3
  billingAddressCity
  billingAddressState
  billingAddressZip
  email
  phone
  phone2
  fax
  notes
  salesUser {
    id
    firstName
    lastName
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "CustomerSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerNumbers",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "salesUserIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customerNumbers",
    "variableName": "customerNumbers"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "salesUserIds",
    "variableName": "salesUserIds"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CustomersQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "customers",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerConnection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerEdge",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "CustomerList_customerEdges",
                "args": null
              }
            ]
          }
        ]
      },
      (v4/*: any*/)
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CustomersQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "customers",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerConnection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "customerNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "openOrders",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "salesUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "avatar",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "primaryContactName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "secondaryContactName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "addresses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CustomerAddress",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine1",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine2",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine3",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressCity",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressState",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressZip",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressCountry",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDefault",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressLine1",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressLine2",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressLine3",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressCity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressState",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressZip",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "phone",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "phone2",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fax",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CustomersQuery",
    "id": null,
    "text": "query CustomersQuery(\n  $count: Int!\n  $offset: Int\n  $search: String\n  $sortBy: CustomerSort\n  $customerNumbers: [String!]\n  $salesUserIds: [ID!]\n) {\n  customers(first: $count, offset: $offset, search: $search, sortBy: $sortBy, customerNumbers: $customerNumbers, salesUserIds: $salesUserIds) {\n    totalCount\n    edges {\n      ...CustomerList_customerEdges\n    }\n  }\n  viewer {\n    id\n    permissions\n  }\n}\n\nfragment CustomerList_customerEdges on CustomerEdge {\n  node {\n    id\n    customerNumber\n    name\n    openOrders\n    salesUser {\n      ...UserAvatar_user\n      id\n    }\n    ...AddUpdateCustomerModal_customer\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment AddUpdateCustomerModal_customer on Customer {\n  id\n  name\n  primaryContactName\n  secondaryContactName\n  addresses {\n    id\n    label\n    addressLine1\n    addressLine2\n    addressLine3\n    addressCity\n    addressState\n    addressZip\n    addressCountry\n    isDefault\n  }\n  billingAddressLine1\n  billingAddressLine2\n  billingAddressLine3\n  billingAddressCity\n  billingAddressState\n  billingAddressZip\n  email\n  phone\n  phone2\n  fax\n  notes\n  salesUser {\n    id\n    firstName\n    lastName\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66d5e9b0277e8ba4662226d930c0ac2e';
module.exports = node;
